import { prop } from 'ramda';
import { useEffect, useState } from 'react';
import { useAppSelector } from 'js/store/hooks';

export const useSetConnection = (isLoaded) => {
    const openApiDomain = useAppSelector(prop('openApiDomain'));
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        if (!isLoaded || !openApiDomain) {
            return;
        }

        const onStatusChange = (socket) => setIsConnected(socket.connected);

        window.Communication.API.common.onConnectionStatusChange(onStatusChange);
        window.Communication.API.common.setConnectionOptions({ url: openApiDomain });
    }, [isLoaded, openApiDomain]);

    return isConnected;
};
